import { useEffect, useState, useCallback } from "react";
import { endpoint } from "../../../../views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const useStudentDetails = (applicationId) => {
  const [studentDetails, setStudentDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStudentDetails = useCallback(async () => {
    if (!applicationId) return;

    setLoading(true);
    setError(null);

    try {
      const payload = {
        applicationId,
      };

      const response = await fetchAllPostPromisedData(
        `${endpoint.getStudentChargesList}?offset=0`,
        payload
      );

      const list =
        response?.data?.studentApplicationDetailsSearchResponseDTOList;

      if (list?.length) {
        setStudentDetails(list[0]); // assuming single student per applicationId
      } else {
        setStudentDetails(null);
      }
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [applicationId]);

  useEffect(() => {
    fetchStudentDetails();
  }, [fetchStudentDetails]);

  return {
    studentDetails,
    loading,
    error,
    refetch: fetchStudentDetails,
  };
};

export default useStudentDetails;
